export enum SafetyProgramRequirementStatus {
  Incomplete = 'Incomplete',
  Completable = 'Completable',
  CompletableNotApplicable = 'CompletableNotApplicable',
  SubmittedNotApplicable = 'SubmittedNotApplicable',
  SubmittedComplete = 'SubmittedComplete',
  AcceptedNotApplicable = 'AcceptedNotApplicable',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  RejectedNotApplicable = 'RejectedNotApplicable',
  ProcessingByAi = 'ProcessingByAi'
}
